/**
 * Validates the project name modal before submitting. Native `required`
 * validation treats whitespace as a value, but the server strips it to blank.
 */
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'error', 'button'];

  validate() {
    const hasWhitespaceOnlyValue =
      this.inputTarget.value.length > 0 && this.inputTarget.value.trim().length === 0;

    this.#toggleError(hasWhitespaceOnlyValue);
  }

  submit(event) {
    if (event.submitter?.formNoValidate) {
      return;
    }

    if (this.inputTarget.value.trim().length > 0) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    this.#toggleError(true);
    this.#enableSubmitButton();
    window.setTimeout(() => this.#enableSubmitButton(), 0);
    this.inputTarget.focus();
  }

  #toggleError(visible) {
    this.inputTarget.classList.toggle('field--error', visible);
    this.errorTarget.classList.toggle('form-error--visible', visible);
  }

  #enableSubmitButton() {
    window.jQuery.rails.enableFormElement(window.jQuery(this.buttonTarget));
  }
}
